import { useNavigate } from "react-router-dom";
import { t } from "ttag";

import { ROUTES } from "@/app/router";
import { Cart5Icon, Header, HeartIcon } from "@/shared/ui";

export const ShopSummaryHeader = () => {
  const navigate = useNavigate();

  return (
    <Header.Root variant="secondary">
      <Header.Content>
        <Header.Breadcrumb
          links={[
            {
              href: ROUTES.SHOP.OVERVIEW,
              icon: Cart5Icon,
              label: t`Shop`,
            },
            {
              href: ROUTES.SHOP.SUMMARY,
              icon: HeartIcon,
              label: t`Checkout`,
            },
          ]}
        />

        <div className="flex gap-2">
          <Header.GoBackButton
            onClick={() => navigate(ROUTES.SHOP.OVERVIEW)}
            className="mt-3.5 md:hidden"
          />
          <Header.Title>{t`Here's your summary`}</Header.Title>
        </div>
      </Header.Content>
    </Header.Root>
  );
};
